import { render, staticRenderFns } from "./goodsReport.vue?vue&type=template&id=4655df27&"
import script from "./goodsReport.vue?vue&type=script&lang=js&"
export * from "./goodsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports